import * as API from '@/api';

export const actions = {
  // R: 取得圖鑑集列表
  async getAlbums({ commit }) {
    const list = await API.GET('/albums?limit=6');

    // 濾掉下架的文章
    list.data.data = list.data.data.filter((album) => album.is_on === 1);

    commit('setAlbums', list.data);
  },

  // R: 取得一篇圖鑑集文章
  async getAlbum({ commit }, articleId) {
    const album = await API.GET(`/albums/${articleId}`);

    if (!album.data.tags) {
      album.data.tags = [];
    }

    commit('setAlbum', album.data);
  },
};